import { createBrowserHistory } from 'umi';
const historys = createBrowserHistory({
  basename: '', //基链接
  forceRefresh: true, //是否强制刷新
});

export { historys };
